import type { RouteObject } from "react-router";
import { CONTACT_ROUTES } from "@/src/contact/constants/contact-routes";
import PublicContactPage from "@/src/contact/pages/public-contact-page";

export const contactRoutes: RouteObject = {
	children: [{ path: CONTACT_ROUTES.CONTACT, element: <PublicContactPage /> }],
};
